<template>
    <div :style="styles" class="c-SoftPhone" v-if="todisplay" v-show="isvisible">
        <div v-if="!callHSM">
            <span>
                <TranslationContainer :context="this" value="Error! Missing CoordinatingHSM"/>
            </span>
        </div>

        <div v-else class="headerbar q-pa-sm row no-wrap items-center">
            <QIcon
                :name="phoneIcon.replace(/^mdi\s+/, '')"
                :color="phoneColorQuasar"
                :class="phoneClasses"
                size="sm"
            >
                <QTooltip position="right">{{ Translate(phoneIconTooltip) }}</QTooltip>
            </QIcon>
            <span class="q-ml-sm">
                {{ phoneTitle }}
            </span>

            <QSpace />

            <QBtn flat dense size="sm" icon="mdi-cancel" :color="doNotDisturbColor" @click="toggleDoNotDisturbClick">
                <QTooltip position="right">{{ Translate('Toggle Do-Not-Disturb') }}</QTooltip>
            </QBtn>

            <QBtn flat dense size="md" :icon="conferenceMode ? 'mdi-account' : 'mdi-account-group'" color="grey" @click="toggleConferenceModeClick" :disable="activeCallList.length > 0">
                <QTooltip position="right">{{ conferenceMode ? Translate('Switch to Normal') : Translate('Switch to Conference Mode') }}</QTooltip>
            </QBtn>
        </div>

        <div class="inputbar q-ma-sm" v-if="!conferenceMode">
            <QSelect
                outlined
                dense
                :label="Translate('From')"
                :options="fromList"
                option-label="text"
                option-value="value"
                emit-value
                map-options
                :model-value="currentFrom"
                @update:model-value="fromChanged"
                class="q-mb-sm"
            />

            <div ref="searchdialWrapper" class="row no-wrap items-center" style="gap: 4px;">
                <QSelect
                    ref="searchdial"
                    outlined
                    dense
                    clearable
                    hide-bottom-space
                    use-input
                    fill-input
                    hide-selected
                    new-value-mode="add-unique"
                    :label="Translate('Search / Dial', false, this)"
                    :placeholder="Translate('Search / Dial', false, this)"
                    :options="filteredToList"
                    option-label="title"
                    :model-value="selectedDialOption"
                    :input-value="dialstring"
                    @filter="onSearchDialFilter"
                    @update:model-value="onSearchDialSelect"
                    @update:input-value="onSearchDialInputValue"
                    @new-value="onSearchDialNewValue"
                    @focus="onSearchDialFocus"
                    @blur="onSearchDialBlur"
                    @keydown.enter.prevent="onSearchDialEnter"
                    class="col"
                    style="min-width: 0;"
                >
                    <template v-if="activeCallList.length > 0" #append>
                        <QBtn flat dense round size="sm" icon="mdi-dialpad" @click.stop="showDialpad = !showDialpad" />
                    </template>
                    <template #option="scope">
                        <QItem v-bind="scope.itemProps">
                            <QItemSection avatar>
                                <QIcon :name="normalizeOptionIcon(scope.opt.icon, scope.opt.value && scope.opt.value.isuser)" size="sm" />
                            </QItemSection>
                            <QItemSection>
                                <QItemLabel>{{ scope.opt.title }}</QItemLabel>
                                <QItemLabel v-if="scope.opt.subtitle" caption>{{ scope.opt.subtitle }}</QItemLabel>
                            </QItemSection>
                            <QItemSection v-if="scope.opt.contact_id" side>
                                <QBtn flat dense size="sm" color="primary" no-caps class="c-SentenceCaseButton" @click.stop="showDetails($event, scope.opt.value)">
                                    <span>{{ Translate('Details') }}</span>
                                </QBtn>
                            </QItemSection>
                        </QItem>
                    </template>
                </QSelect>
            </div>
        </div>

        <div class="dialpad q-ma-sm" v-if="!conferenceMode && showDialpad && activeCallList.length > 0">
            <QInput
                outlined
                dense
                hide-bottom-space
                class="q-mb-sm"
                v-model="dtmfHistory"
                @keydown="dtmfInput"
            />

            <div class="row">
                <QBtn flat size="lg" @click="senddtmf('1')">
                    <div class="dialpadbutton">
                        <div class="digit">1</div>
                        <div class="alpha" style="opacity: 0;">_</div>
                    </div>
                </QBtn>
                <QBtn flat size="lg" @click="senddtmf('2')">
                    <div class="dialpadbutton">
                        <div class="digit">2</div>
                        <div class="alpha">ABC</div>
                    </div>
                </QBtn>
                <QBtn flat size="lg" @click="senddtmf('3')">
                    <div class="dialpadbutton">
                        <div class="digit">3</div>
                        <div class="alpha">DEF</div>
                    </div>
                </QBtn>
            </div>

            <div class="row">
                <QBtn flat size="lg" @click="senddtmf('4')">
                    <div class="dialpadbutton">
                        <div class="digit">4</div>
                        <div class="alpha">GHI</div>
                    </div>
                </QBtn>
                <QBtn flat size="lg" @click="senddtmf('5')">
                    <div class="dialpadbutton">
                        <div class="digit">5</div>
                        <div class="alpha">JKL</div>
                    </div>
                </QBtn>
                <QBtn flat size="lg" @click="senddtmf('6')">
                    <div class="dialpadbutton">
                        <div class="digit">6</div>
                        <div class="alpha">MNO</div>
                    </div>
                </QBtn>
            </div>

            <div class="row">
                <QBtn flat size="lg" @click="senddtmf('7')">
                    <div class="dialpadbutton">
                        <div class="digit">7</div>
                        <div class="alpha">PQRS</div>
                    </div>
                </QBtn>
                <QBtn flat size="lg" @click="senddtmf('8')">
                    <div class="dialpadbutton">
                        <div class="digit">8</div>
                        <div class="alpha">TUV</div>
                    </div>
                </QBtn>
                <QBtn flat size="lg" @click="senddtmf('9')">
                    <div class="dialpadbutton">
                        <div class="digit">9</div>
                        <div class="alpha">WXYZ</div>
                    </div>
                </QBtn>
            </div>

            <div class="row">
                <QBtn flat size="lg" @click="senddtmf('*')">
                    <div class="dialpadbutton">
                        <div class="digit">*</div>
                        <div class="alpha" style="opacity: 0;">_</div>
                    </div>
                </QBtn>
                <QBtn flat size="lg" @click="senddtmf('0')">
                    <div class="dialpadbutton">
                        <div class="digit">0</div>
                        <div class="alpha">+</div>
                    </div>
                </QBtn>
                <QBtn flat size="lg" @click="senddtmf('#')">
                    <div class="dialpadbutton">
                        <div class="digit">#</div>
                        <div class="alpha" style="opacity: 0;">_</div>
                    </div>
                </QBtn>
            </div>
        </div>

        <div class="dialbar q-ma-sm row no-wrap items-center" v-if="!conferenceMode">
            <div style="flex-shrink: 0;">
                <QBtn flat dense size="md" class="q-ml-sm" icon="mdi-cog" color="primary" @click="phoneSettingsIconClicked" round>
                    <QTooltip position="right">{{ Translate('Phone Settings') }}</QTooltip>
                </QBtn>
            </div>
            <QSpace />
            <QBtn v-if="activeCallList.length < 1" color="primary" unelevated no-caps class="c-SentenceCaseButton" @click="callClicked" :disable="callButtonDisabled">
                <span>{{ Translate('Call') }}</span>
            </QBtn>
            <div v-if="activeCallList.length >= 1" class="row no-wrap items-center hold-dial-split">
                <QBtn color="primary" unelevated no-caps class="c-SentenceCaseButton ThemeRightConnector" style="border-right: 1px solid var(--v-lightGreyBorder-base) !important;" @click="holdAndDialClicked">
                    <span>{{ Translate('Hold and dial') }}</span>
                </QBtn>
                <QBtn color="primary" unelevated icon="mdi-arrow-down-drop-circle" class="text-white ThemeLeftConnector">
                    <QMenu anchor="bottom end" self="top end">
                        <QList dense class="PopupMenuButtons">
                            <QItem clickable v-ripple @click="addCallClicked">
                                <QItemSection>
                                    <QItemLabel>{{ Translate('Add call (conference)') }}</QItemLabel>
                                </QItemSection>
                            </QItem>
                            <QItem clickable v-ripple @click="blindTransferClicked">
                                <QItemSection>
                                    <QItemLabel>{{ Translate('Blind transfer') }}</QItemLabel>
                                </QItemSection>
                            </QItem>
                        </QList>
                    </QMenu>
                </QBtn>
            </div>
        </div>
        <div class="conferencebar q-ma-sm" v-if="conferenceMode">
            <QBtn flat dense size="md" class="q-ml-sm" icon="mdi-cog" color="primary" @click="conferenceSettingsIconClicked">
                <QTooltip position="right">{{ Translate('Conference Settings') }}</QTooltip>
            </QBtn>
            <QBtn color="primary" unelevated no-caps class="c-SentenceCaseButton" v-if="callHSM.CurrentState == 'Master.Idle'" :disable="!callHSM.Vars.Mailbox.ConferenceBridge.Enabled" @click="startConferenceClicked">
                <span>{{ Translate('Start conference') }}</span>
            </QBtn>
            <QBtn color="primary" unelevated no-caps class="c-SentenceCaseButton" v-if="callHSM.CurrentState == 'Master.Conference' && conferenceStatus.AsModerator" @click="endConferenceClicked">
                <span>{{ Translate('End conference') }}</span>
            </QBtn>
            <QBtn color="primary" unelevated no-caps class="c-SentenceCaseButton" v-if="callHSM.CurrentState == 'Master.Idle'" @click="joinConferenceClicked">
                <span>{{ Translate('Join conference') }}</span>
            </QBtn>
            <QBtn color="primary" unelevated no-caps class="c-SentenceCaseButton" v-if="callHSM.CurrentState == 'Master.Conference' && !conferenceStatus.AsModerator" @click="leaveConferenceClicked">
                <span>{{ Translate('Leave conference') }}</span>
            </QBtn>
        </div>
        <div class="activecalls q-ma-sm" v-if="generalCallControlsVisible">
            <div class="generalcallcontrols q-pa-sm">
                <QBtn outline color="primary" no-caps class="c-SentenceCaseButton" @click="muteClicked">
                    <span>{{ callHSM.Vars.ALegHSM.Vars.Muted ? Translate('Unmute') : Translate('Mute') }}</span>
                    <QIcon :name="callHSM.Vars.ALegHSM.Vars.Muted ? 'mdi-microphone-off' : 'mdi-microphone'" size="xs" class="softphone-btn-icon" />
                </QBtn>

                <QSpace />

                <QBtn color="red" outline unelevated no-caps class="q-mr-sm c-SentenceCaseButton" @click="dropOut" v-if="!conferenceMode && activeCallList.length > 1" :disable="!canDropOut">
                    <span>{{ Translate('Drop out') }}</span>
                    <QIcon name="mdi-location-exit" size="xs" class="softphone-btn-icon" />
                </QBtn>

                <QBtn color="negative" unelevated no-caps class="c-SentenceCaseButton" @click="endAllClicked" v-if="!conferenceMode">
                    <span>{{ activeCallList.length > 1 ? Translate('End all') : Translate('End') }}</span>
                    <QIcon name="mdi-phone-hangup" size="xs" class="softphone-btn-icon" />
                </QBtn>

                <span v-if="conferenceMode && callHSM.Vars.ALegHSM.CurrentState=='Listening.Active' && conferenceStatus.ModeratorName">
                    {{ Translate('Moderator:') }} {{ conferenceStatus.ModeratorName }}
                </span>
            </div>

            <div class="callcontrolscontainer">

                <div v-bind:class="{ callcontrols: true, 'q-pa-md': true, [conferenceMode ? 'call_state_conference' : item.class]: true }"
                     v-for="(item, index) in activeCallList" :key="index">

                    <QBtn v-if="!conferenceMode" :color="item.holdrestore.color" :icon="item.holdrestore.icon" unelevated no-caps class="text-white" @click="callControlClicked(item.call)">
                        <QTooltip position="right">{{ Translate(item.holdrestore.tooltip) }}</QTooltip>
                    </QBtn>

                    <QIcon :name="item.call.Vars.Call && item.call.Vars.Call.Talking && !item.call.Vars.Muted ? 'mdi-volume-high' : 'mdi-volume-low'" size="sm" />

                    <QBtn v-if="conferenceMode" color="negative" flat unelevated size="md" :icon="item.call.Vars.Muted ? 'mdi-microphone-off' : 'mdi-microphone'" text-color="dark" @click="conferenceMemberToggleMute(item.call)">
                        <QTooltip position="right">{{ Translate('Mute') }}</QTooltip>
                    </QBtn>

                    <ElapsedTime :starttime="item.StartTime"></ElapsedTime>

                    <div style="display: flex; flex-direction: column; align-items: start;">
                        <span class="from_title">{{ item.title }}</span>
                        <span class="from_subtitle">{{ item.subtitle }}</span>
                    </div>

                    <QSpace />

                    <QBtn v-if="conferenceMode && conferenceStatus.AsModerator && item.call.Vars.RaisedHand" color="negative" flat unelevated @click="item.call.Vars.RaisedHand = false">
                        <QTooltip position="right">{{ Translate('Participant\'s hand is raised') }}</QTooltip>
                        <QIcon name="mdi-hand-back-right-outline" color="positive" size="sm" />
                    </QBtn>

                    <QBtn v-if="activeCallList.length > 1" color="negative" flat unelevated icon="mdi-phone-hangup" @click="endOneCall(item.call)">
                        <QTooltip position="right">{{ Translate('Hang up') }}</QTooltip>
                    </QBtn>

                    <QBtn flat dense icon="mdi-dots-vertical">
                        <QMenu anchor="bottom end" self="top end">
                            <QList dense class="PopupMenuButtons">
                                <QItem clickable v-ripple @click="copySessionID(item.call)">
                                    <QItemSection>
                                        <QItemLabel>{{ Translate('Copy session ID') }}</QItemLabel>
                                    </QItemSection>
                                </QItem>
                            </QList>
                        </QMenu>
                    </QBtn>
                </div>

            </div>
        </div>
    
        <div class="alertingbar q-ma-sm" v-if="incomingAlerting">
            <span>{{ Translate('You have an incoming call from') }}</span>

            <AsyncTextblock :settings="incomingCallFromSettings" class="incomingAlertingStyles"></AsyncTextblock>

            <div class="incomingAlertingButtons">
                <QBtn color="positive" unelevated no-caps class="c-SentenceCaseButton" @click="acceptIncomingCall">
                    <span>{{ Translate('Accept') }}</span>
                    <QIcon name="mdi-phone" size="xs" class="softphone-btn-icon" />
                </QBtn>

                <QBtn color="negative" unelevated no-caps class="c-SentenceCaseButton" @click="declineIncomingCall">
                    <span>{{ Translate('Decline') }}</span>
                    <QIcon name="mdi-phone-missed" size="xs" class="softphone-btn-icon" />
                </QBtn>
            </div>
        </div>

        <QDialog v-model="showJoinConferenceDialog" persistent style="max-width: 735px;">
            <QCard>
                <QBar class="bg-primary text-white" style="height: 60px;">
                    <QToolbarTitle class="text-white">
                        {{ Translate('Join Conference') }}
                    </QToolbarTitle>
                    <QSpace />
                    <QBtn flat round dense icon="mdi-close" class="text-white" @click="showJoinConferenceDialog=false" />
                </QBar>

                <QCardSection class="q-mt-sm q-pa-md">
                    <p style="font-size: larger;">
                        {{ Translate('Please choose the moderator of the conference to join:') }}
                    </p>

                    <div class="q-mt-md">
                        <QSelect
                            outlined
                            dense
                            autofocus
                            clearable
                            label="Moderator Name"
                            :options="moderatorNames"
                            option-label="text"
                            option-value="value"
                            emit-value
                            map-options
                            :model-value="moderatorUserID"
                            @update:model-value="moderatorInput"
                            @focus="loadModeratorNamesFocused"
                            @keydown.enter.prevent="moderatorNamesEnter"
                        />
                    </div>
                </QCardSection>

                <QCardActions align="right">
                    <QBtn color="primary" unelevated no-caps class="c-SentenceCaseButton" @click="moderatorAccept" :disable="!moderatorUserID">
                        <span>{{ Translate('OK') }}</span>
                    </QBtn>
                    <QBtn color="grey-7" flat no-caps class="c-SentenceCaseButton" @click="showJoinConferenceDialog=false">
                        <span>{{ Translate('Cancel') }}</span>
                    </QBtn>
                </QCardActions>
            </QCard>
        </QDialog>

        <QDialog
            v-model="showContactDetails"
            persistent
            :maximized="false"
            style="max-width: 450px;"
            v-if="showContactDetails"
        >
            <QCard style="width: 450px; max-width: 100%;">
                <QBar flat class="bg-grey-3">
                    <span class="text-h6">Contact Details</span>
                    <QSpace />
                    <QBtn flat round dense icon="mdi-close" color="grey-7" @click="showContactDetails = false" />
                </QBar>

                <QCardSection>
                    <div class="row q-col-gutter-md">
                        <div class="col-12 col-sm-6 col-md-4">
                            <div class="column" style="font-size: 1rem;">
                                <span class="text-caption">{{ Translate('First name') }}</span>
                                <span>{{ selectedContact.first_display }}</span>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4">
                            <div class="column" style="font-size: 1rem;">
                                <span class="text-caption">{{ Translate('Last name') }}</span>
                                <span>{{ selectedContact.last_display }}</span>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4">
                            <div class="column" style="font-size: 1rem;">
                                <span class="text-caption">{{ Translate('Middle name') }}</span>
                                <span>{{ selectedContact.middle_display }}</span>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4">
                            <div class="column" style="font-size: 1rem;">
                                <span class="text-caption">{{ Translate('Job title') }}</span>
                                <span>{{ selectedContact.JobTitle }}</span>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4">
                            <div class="column" style="font-size: 1rem;">
                                <span class="text-caption">{{ Translate('Company') }}</span>
                                <span>{{ selectedContact.CompanyName }}</span>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4">
                            <div class="column" style="font-size: 1rem;">
                                <span class="text-caption">{{ Translate('Department') }}</span>
                                <span>{{ selectedContact.Department }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="q-mt-md">
                        <div class="text-h6 q-mb-sm">{{ Translate('Phone Numbers') }}</div>
                        <QOptionGroup
                            v-model="selectedPhoneNumberValue"
                            :options="(selectedContact.PhoneNumbers || []).map((phoneNumber, index) => ({
                                label: `${phoneNumber.type}: ${util.formatPhoneNumber(phoneNumber.phonenumber)}`,
                                value: index
                            }))"
                            type="radio"
                            inline
                        />
                    </div>
                </QCardSection>

                <QCardActions>
                    <QSpace />
                    <QBtn color="primary" unelevated no-caps class="full-width c-SentenceCaseButton" @click="selectedContactNumber">
                        <span>{{ Translate('Select') }}</span>
                    </QBtn>
                    <QSpace />
                </QCardActions>
            </QCard>
        </QDialog>
    </div>
</template>

<script>
    //import Vue from 'vue';
    import {
        QTooltip, QIcon, QBtn, QSelect, QInput, QMenu, QList, QItem, QItemSection, QItemLabel,
        QDialog, QCard, QCardSection, QCardActions, QBar, QToolbarTitle, QSpace,
        QOptionGroup,
    } from 'quasar';
    import BaseComponent from './BaseComponentMixin.jsx';
    import EventBus from '../event-bus.js';
    import utils from '../../Shared/utils.jsx';
    import token from '@/Services/token';
    import careHelpfulFunctions from '@/Application/careHelpfulFunctions.jsx';

    import ElapsedTime from './vuecontrols/elapsedTimer.vue';
    import AsyncTextblock from './vuecontrols/asyncTextblock.vue';
    import TranslationContainer from './TranslationContainer.jsx';
    import './css/BasicButton.css';

    export default {
        name: 'SoftPhone',
        mixins: [BaseComponent],
        components: {
            QTooltip, QIcon, QBtn, QSelect, QInput, QMenu, QList, QItem, QItemSection, QItemLabel,
            QDialog, QCard, QCardSection, QCardActions, QBar, QToolbarTitle, QSpace,
            QOptionGroup,
            ElapsedTime,
            AsyncTextblock,
            TranslationContainer,
        },
        data: function () {
            return {
                callHSM: null,
                conferenceMode: false,
                conferenceStatus: {},

                currentFrom: null,
                fromList: [],
                toList: [],
                toContactList: [],
                toSelected: -1,
                dialstring: '',
                searchby: '',
                phoneTitle: 'Phone',
                selectedDialOption: null,
                // Quasar use-input @filter often fires "" on focus/blur; ignore those until the user edits.
                searchDialDirty: false,

                x: 0,
                y: 0,
                widthToList: '100%',
                showingToList: false,

                showContactDetails: false,
                selectedContact: null,
                contactSelectable: false,
                selectedPhoneNumberValue: 0,

                showDialpad: false,
                dtmfHistory: '',

                bleg_status: {
                    'Interacting.Listening.WaitingForAnswer': {
                        class: 'call_state_dialing',
                        icon: 'mdi-dots-horizontal',
                        color: 'primary',
                        tooltip: '',
                    },
                    'Interacting.Listening.Active.Linked': {
                        class: 'call_state_normal',
                        icon: 'mdi-pause',
                        color: 'success',
                        tooltip: '',
                    },
                    'Interacting.Listening.Active.Unlinked': {
                        class: 'call_state_onhold',
                        icon: 'mdi-play',
                        color: 'warning',
                        tooltip: '',
                    },
                    'Interacting.Dropped': {
                        class: 'call_state_dropped',
                        icon: 'mdi-phone-hangup-outline',
                        color: 'error',
                        tooltip: '',
                    },
                    'Interacting.WrapUp': {
                        class: 'call_state_wrapup',
                        icon: '',
                        color: 'primary',
                        tooltip: '',
                    }
                },

                callerIdName: null,

                showJoinConferenceDialog: false,
                moderatorNames: [],
                moderatorUserID: null,
            }
        },
        //Mounted Replaced with preRenderComplete
        created() {
            if (this.controlData.CoordinatingHSMName)
                this.callHSM = this.Root.ChildControlByName(this.controlData.CoordinatingHSMName);
        },
        computed: {
            util: function () {
                return careHelpfulFunctions;
            },
            styles: function () {
                return {
                    ...utils.resolveStyleHints(this.styleHints, this),
                    ...this.sizeStyle,
                    display: 'flex',
                    flexDirection: 'column'
                }
            },
            test_Aleg_status: function () {
                return (this.callHSM.Vars.ALegHSM.CurrentState || 'NA') + ' ' + (this.callHSM.CurrentState || 'NA');
            },
            phoneIcon: function () {
                if (this.callHSM.Vars.ALegHSM && this.callHSM.Vars.ALegHSM.CurrentState && (this.callHSM.Vars.ALegHSM.CurrentState == 'Dialing' || this.callHSM.Vars.ALegHSM.CurrentState == 'Listening.WaitingForAnswer'))
                    return 'mdi mdi-refresh';
                else
                    return 'mdi-phone';
            },
            phoneColor: function () {
                if (!this.callHSM.Vars.ALegHSM || !this.callHSM.Vars.ALegHSM.CurrentState)
                    return 'grey';
                else if (this.callHSM.Vars.ALegHSM && this.callHSM.Vars.ALegHSM.CurrentState && (this.callHSM.Vars.ALegHSM.CurrentState == 'Listening.Disconnecting' || this.callHSM.Vars.ALegHSM.CurrentState == 'Failed' || this.callHSM.Vars.ALegHSM.CurrentState == 'Dropped'))
                    return 'black';
                else if (this.callHSM.Vars.ALegHSM && this.callHSM.Vars.ALegHSM.CurrentState && (this.callHSM.Vars.ALegHSM.CurrentState.substring(0, 16) == 'Listening.Active' || this.callHSM.Vars.ALegHSM.CurrentState == 'Listening.Transferring'))
                    return 'green';
                else if (this.callHSM.Vars.ALegHSM && this.callHSM.Vars.ALegHSM.CurrentState && (this.callHSM.Vars.ALegHSM.CurrentState == 'Dialing' || this.callHSM.Vars.ALegHSM.CurrentState == 'Listening.WaitingForAnswer'))
                    return 'blue';
                else
                    return '';
            },
            phoneColorQuasar: function () {
                const v = this.phoneColor;
                if (v === 'green') return 'positive';
                if (v === 'blue') return 'primary';
                if (v === 'grey' || v === 'gray') return 'grey';
                if (v === 'black') return 'dark';
                return v || 'grey';
            },
            phoneIconTooltip: function () {
                if (!this.callHSM.Vars.ALegHSM || !this.callHSM.Vars.ALegHSM.CurrentState)
                    return 'Soft phone disconnected';
                else if (this.callHSM.Vars.ALegHSM && this.callHSM.Vars.ALegHSM.CurrentState && (this.callHSM.Vars.ALegHSM.CurrentState == 'Listening.Disconnecting' || this.callHSM.Vars.ALegHSM.CurrentState == 'Failed' || this.callHSM.Vars.ALegHSM.CurrentState == 'Dropped'))
                    return 'Soft phone disconnecting...';
                else if (this.callHSM.Vars.ALegHSM && this.callHSM.Vars.ALegHSM.CurrentState && (this.callHSM.Vars.ALegHSM.CurrentState.substring(0, 16) == 'Listening.Active' || this.callHSM.Vars.ALegHSM.CurrentState == 'Listening.Transferring'))
                    return 'Soft phone connected';
                else if (this.callHSM.Vars.ALegHSM && this.callHSM.Vars.ALegHSM.CurrentState && (this.callHSM.Vars.ALegHSM.CurrentState == 'Dialing' || this.callHSM.Vars.ALegHSM.CurrentState == 'Listening.WaitingForAnswer'))
                    return 'Soft phone dialing...';
                else
                    return 'Soft phone disconnected';
            },
            phoneClasses: function () {
                if (this.callHSM.Vars.ALegHSM && this.callHSM.Vars.ALegHSM.CurrentState && (this.callHSM.Vars.ALegHSM.CurrentState == 'Dialing' || this.callHSM.Vars.ALegHSM.CurrentState == 'Listening.WaitingForAnswer'))
                    return 'mdi-animate-spin';
                else
                    return null;
            },

            doNotDisturbColor: function () {
                return this.callHSM.Vars.DoNotDisturb ? 'red' : 'gray';
            },


            callButtonDisabled: function () {
                return this.callHSM.CurrentState == 'Master.Interactive' || this.callHSM.CurrentState == 'Disabled';
            },

            generalCallControlsVisible: function () {
                return this.callHSM.Vars && this.callHSM.Vars.ALegHSM && this.callHSM.Vars.ALegHSM.CurrentState == 'Listening.Active';
            },

            filteredToList: function () {
                if (this.searchby) {
                    var searchVal = this.searchby.toLowerCase();
                    var searchList = this.toList.filter(a => this.optionMatchesSearch(a, searchVal));
                    searchList = searchList.concat(this.toContactList);
                    return searchList;
                } else {
                    return this.toList;
                }
            },

            activeCallList: function () {
                if (this.callHSM && this.callHSM.Vars && this.callHSM.Vars.BLegHSMs) {
                    const blegs = this.callHSM.Vars.BLegHSMs;
                    const items = Object.keys(blegs)
                        .map(k => blegs[k])
                        .map(b => ({
                            CurrentState: b.CurrentState,

                            StartTime: (b.Vars.Call && b.Vars.Call.StartTime) ? Date.parse(b.Vars.Call.StartTime) : new Date(),

                            title: this.getTitle(b),
                            subtitle: this.getSubtitle(b),
                            original: this.getOriginal(b),
                            class: this.bleg_status[b.CurrentState] ? this.bleg_status[b.CurrentState].class : '',
                            holdrestore: {
                                icon: this.bleg_status[b.CurrentState] ? this.bleg_status[b.CurrentState].icon : '',
                                color: this.bleg_status[b.CurrentState] ? this.bleg_status[b.CurrentState].color : '',
                                tooltip: this.bleg_status[b.CurrentState] ? this.bleg_status[b.CurrentState].tooltip : '',
                            },

                            call: b,
                        }));

                    return items;
                }
                else
                    return [];

                return [
                    {
                        SessionId: 'abc',
                        State: 'Linked',
                        StartTime: new Date().toISOString(),

                        title: 'Lehi Polycom',
                        subtitle: '(801) 727-3538',
                        class: 'call_state_normal',
                        holdrestore: {
                            icon: 'mdi-pause',
                            color: 'success',
                            tooltip: 'Click to Hold',
                        }
                    },
                    {
                        SessionId: 'xyz',
                        State: 'Unlinked',
                        StartTime: new Date().toISOString(),

                        title: 'David Peterson',
                        subtitle: '(801) 557-9028',
                        class: 'call_state_onhold',
                        holdrestore: {
                            icon: 'mdi-play',
                            color: 'warning',
                            tooltip: 'Click to Restore',
                        }
                    }
                ];
            },

            agentInfo: function () {
                if (this.callHSM.Vars.ALegHSM && this.callHSM.Vars.ALegHSM.CurrentState && this.callHSM.Vars.ALegHSM.CurrentState.substring(0, 16) == 'Listening.Active')
                    return this.callHSM.Vars.ALegHSM.Vars?.Call?.SessionId;
                else
                    return '';
            },

            incomingAlerting: function () {
                return this.callHSM.Vars.ALegHSM && this.callHSM.Vars.ALegHSM.Vars && this.callHSM.Vars.ALegHSM.ParamByName('Direction', false, true) == 'IB' && (this.callHSM.Vars.ALegHSM.CurrentState == 'Listening.Alerting' || this.callHSM.Vars.ALegHSM.CurrentState == 'Listening.WaitingForAnswer');
            },
            incomingCallFromSettings: function () {
                const settings = {
                    parent: this,
                    default_text: '',
                    url: null,
                    modelas: 'data',
                    result_expression: null,
                };

                if (this.callHSM.Vars.IncomingCall.CallerId && this.callHSM.Vars.IncomingCall.CallerId.substr(0, 4) !== 'USER') {
                    settings.default_text = this.f_phoneNumber((this.callHSM.Vars.IncomingCall.CallerName || this.callHSM.Vars.IncomingCall.CallerId));
                }
                else if (this.callHSM.Vars.IncomingCall.CallerId && this.callHSM.Vars.IncomingCall.CallerId.substr(0, 4) == 'USER') {
                    settings.default_text = 'Reading...';
                    settings.url = `Apps/Common/UserPhoneContact/fullname?PhoneNumber=${this.callHSM.Vars.IncomingCall.CallerId}`;
                    settings.result_expression = 'data != "NotFound" ? data : "Internal User"';
                }

                return settings;
            },

            canDropOut: function() {
                return !this.activeCallList.some(b => b.CurrentState == 'Interacting.Listening.WaitingForAnswer');
            },
        },
        methods: {
            preRenderComplete() {
                this.finishRenderHandler(this);
                this.loadFromList();
                this.loadToList();
                this.loadUserExtension();
            },
            async loadFromList() {
                this.currentFrom = this.System.LocalStorage('pbx-phone-from');

                const data = await utils.api.get('Apps/Common/v2/ListMyCallerIDs');
                this.fromList = data.map(a => ({
                    text: a.Name,
                    value: a.Value,
                }));

                if (!this.currentFrom && this.fromList.length > 0)
                    this.currentFrom = this.fromList[0].value;
            },
            fromChanged(value) {
                this.currentFrom = value;
                this.System.LocalStorage('pbx-phone-from', value);
            },
            getToSubTitle(data) {
                let subTitle = '';

                if (data.isuser) {
                    subTitle += this.Translate('Internal User')
                } else if (data.integrationName) {
                    subTitle += this.Translate(data.subtitle) + ' - ' + careHelpfulFunctions.formatPhoneNumber(data.phonenumber)
                } else {
                    subTitle += careHelpfulFunctions.formatPhoneNumber((data.phonenumber || data.subtitle))
                }

                if (data.last_called) {
                    subTitle += ((data.phonenumber || data.subtitle) ? ' - ' : '') + ' ' + this.f_date(data.last_called, 'medium');
                }

                return subTitle;

            },
            async loadToList() {
                const data = await utils.api.get('Apps/Common/LastCallsDialed');
                this.toList = data.map(a => {
                    const title = careHelpfulFunctions.formatPhoneNumber(a.name || a.title);
                    const subtitle = this.getToSubTitle(a);
                    const text = a.isuser ? (a.name || a.title) : (a.phonenumber || a.subtitle || a.title);
                    return {
                        text,
                        title,
                        subtitle,
                        value: a,
                        icon: this.normalizeOptionIcon(a.icon, a.isuser),
                        searchby: [title, subtitle, text, a.phonenumber, a.name].filter(Boolean).join(' '),
                    };
                });
            },
            optionMatchesSearch(option, searchVal) {
                const haystack = [
                    option.searchby,
                    option.title,
                    option.subtitle,
                    option.text,
                    option.phonenumber,
                    option.value && (option.value.phonenumber || option.value.name || option.value.title || option.value.searchby),
                ].filter(Boolean).join(' ').toLowerCase();
                return haystack.includes(searchVal);
            },
            normalizeOptionIcon(icon, isuser) {
                if (isuser) return 'mdi-account';
                let s = String(icon || '').trim().replace(/^\s*mdi\s+/i, '').trim();
                if (!s) return 'mdi-phone';
                if (!s.startsWith('mdi-') && !s.includes(':'))
                    s = `mdi-${s}`;
                return s;
            },
            fromMenuInput(value) {
                this.fromMenuVisible = value;
            },
            async loadUserExtension() {
                const data = await utils.api.get('Apps/Common/HomeData');
                if (data)
                    this.phoneTitle = `${data.FullName}${data.UserExtension ? ` x.${data.UserExtension}` : ''}`;
            },

            toggleDoNotDisturbClick(e) {
                this.callHSM.sendEvent('ToggleDND', undefined, undefined, { });
            },
            toggleConferenceModeClick(e) {
                this.conferenceMode = !this.conferenceMode;
            },

            getTitle(b) {
                let title = '';
                if (!b.Vars.Call)
                    return title;

                if (b.Vars.Call.Destination.substring(0, 4) == 'USER')
                    title = b.Vars.Call.CallerDisplayName;
                else
                    title = careHelpfulFunctions.formatPhoneNumber(b.Vars.Call.CallerDisplayName);

                return title;

                // If   : b.Vars.Call.Outbound && b.Vars.Call.Destination.substring(0,4)!=='USER' && b.Vars.Call.Destination.trim() !== b.Vars.Call.CallerDisplayName.trim()
                // Then : b.Vars.Call.Destination | phoneNumber
            },
            getSubtitle(b) {
                if (!b.Vars.Call)
                    return '';

                if (b.Vars.Call.Outbound && b.Vars.Call.Destination?.substring(0, 4) !== 'USER' && b.Vars.Call.Destination?.trim() !== b.Vars.Call.CallerDisplayName?.trim())
                    return this.f_phoneNumber(b.Vars.Call.Destination);
                else if (!b.Vars.Call.Outbound && b.Vars.Call.CallerId?.substring(0, 4) !== 'USER' && b.Vars.Call.CallerId?.trim() !== b.Vars.Call.CallerDisplayName?.trim())
                    return this.f_phoneNumber(b.Vars.Call.CallerId);
                else if ((b.Vars.Call.Outbound && b.Vars.Call.Destination?.substring(0, 4) == 'USER') || (!b.Vars.Call.Outbound && b.Vars.Call.CallerId?.substring(0, 4) == 'USER'))
                    return this.Translate('Internal User');
                else
                    return '';
            },
            getOriginal(b) {
                if (!b.Vars.Call)
                    return '';

                if (b.Vars.Call.Payload && b.Vars.Call.Payload.originaldirection == 'inbound' && b.Vars.Call.Payload.originalcallerid?.substring(0, 4) !== 'USER')
                    return this.f_phoneNumber(b.Vars.Call.Payload.originalcallerid);
                else if (b.Vars.Call.Payload && b.Vars.Call.Payload.originaldirection == 'outbound' && b.Vars.Call.Payload.originalcallerid?.substring(0, 4) !== 'USER')
                    return this.f_phoneNumber(b.Vars.Call.Payload.originaldestination);
                else
                    return '';
            },
            showDetails(event, contact) {
                event.stopPropagation();
                this.selectedContact = contact;
                this.contactSelectable = contact.PhoneNumbers.length > 1;
                this.showContactDetails = true;
                this.selectedPhoneNumberValue = 0;
            },
            selectedContactNumber() {
                if (this.selectedPhoneNumberValue != -1) {
                    this.dialstring = this.selectedContact.PhoneNumbers[this.selectedPhoneNumberValue].phonenumber;
                    this.toSelected = -1;
                }

                this.showContactDetails = false;
            },
            selectToItem(value) {
                this.dialstring = value.value.isuser ? value.title : value.contact_id ? value.phonenumber : (value.text || value.title);
                this.toSelected = -1;
            },
            async showToList(items) {
                this.showingToList = false;
                const el = this.$refs.searchdial?.$el;
                if (el) {
                    const rect = el.getBoundingClientRect();
                    this.x = rect.left;
                    this.y = rect.bottom;
                }

                if (items)
                    this.toList = items;
                else
                    await this.loadToList();

                this.$nextTick(() => {
                    this.showingToList = true
                });
            },
            onSearchDialFocus() {
                this.searchDialDirty = false;
                if (this.toList.length === 0)
                    this.loadToList();
            },
            syncSearchDialInput() {
                // Quasar QSelect ignores :input-value; keep the visible box in sync with dialstring
                // after blur reset, Call/Hold-and-Dial fill, and post-dial clear.
                this.$nextTick(() => {
                    const select = this.$refs.searchdial;
                    if (select && typeof select.updateInputValue === 'function')
                        select.updateInputValue(this.dialstring || '', true, true);
                });
            },
            onSearchDialBlur() {
                // Quasar QSelect focus-out emits blur then resetInputValue() to "" when
                // fill-input + hide-selected and there is no model. dialstring is still set;
                // refill the visible input after that reset (skip when empty so clear stays clear).
                if (!this.dialstring)
                    return;
                this.syncSearchDialInput();
            },
            applySearchDialText(val, { fromFilter = false } = {}) {
                const next = val ?? '';
                // Quasar focus/blur often @filter's with "". Those are not edits — keep the committed dialstring.
                if (!this.searchDialDirty && next === '' && this.dialstring) {
                    if (fromFilter)
                        return false;
                    // Same for input-value resets after hide-selected clears the model.
                    return false;
                }
                if (next !== '')
                    this.searchDialDirty = true;

                this.selectedDialOption = null;
                this.dialstring = next;
                this.searchby = this.dialstring;
                return true;
            },
            syncSearchDialOptions() {
                if (this.dialstring && this.dialstring.length > 1 &&
                    this.callHSM.Vars.AutoCompleteItems && this.callHSM.Vars.AutoCompleteItems.length) {
                    this.toList = this.callHSM.Vars.AutoCompleteItems.map(a => ({
                        text: a.isuser ? a.userid : a.title,
                        title: careHelpfulFunctions.formatPhoneNumber(a.title),
                        subtitle: a.subtitle,
                        value: a,
                        icon: this.normalizeOptionIcon(a.icon, a.isuser),
                        searchby: a.searchby || a.title || a.subtitle,
                    }));
                } else if (!this.dialstring || this.dialstring.length <= 1) {
                    this.toContactList = [];
                }
            },
            onSearchDialFilter(val, update) {
                const applied = this.applySearchDialText(val, { fromFilter: true });

                // Apply autocomplete matches synchronously so Quasar can refresh immediately.
                // Contact search continues asynchronously and triggers a second refresh.
                if (applied)
                    this.syncSearchDialOptions();

                update();
                if (applied)
                    this.dialstringChanged().finally(() => update());
            },
            onSearchDialSelect(opt) {
                if (opt) {
                    this.selectToItem(opt);
                    this.searchby = this.dialstring;
                    this.searchDialDirty = false;
                } else {
                    // clearable
                    this.dialstring = '';
                    this.searchby = '';
                    this.toContactList = [];
                    this.searchDialDirty = false;
                }
                this.selectedDialOption = null;
            },
            onSearchDialInputValue(val) {
                if (!this.applySearchDialText(val))
                    return;
                this.dialstringChanged();
            },
            onSearchDialNewValue(val) {
                this.applySearchDialText(val);
                this.searchDialDirty = false;
            },
            onSearchDialEnter() {
                if (this.dialstring && this.filteredToList.length < 1)
                    this.dialPhone();
                else if (this.filteredToList.length > 0 && this.$refs.searchdial) {
                    const first = this.filteredToList[0];
                    this.selectToItem(first);
                }
            },
            dialstringClick(e) {
                e.preventDefault();
                this.searchby = '';
                this.showToList();
            },
            async dialstringChanged() {
                this.searchby = this.dialstring || '';

                if (this.dialstring && this.dialstring.length > 1) {
                    if (this.callHSM.Vars.AutoCompleteItems && this.callHSM.Vars.AutoCompleteItems.length) {
                        let items = this.callHSM.Vars.AutoCompleteItems.map(a => ({
                            text: a.isuser ? a.userid : a.title,
                            title: careHelpfulFunctions.formatPhoneNumber(a.title),
                            subtitle: a.subtitle,
                            value: a,
                            icon: this.normalizeOptionIcon(a.icon, a.isuser),
                            searchby: a.searchby || a.title || a.subtitle,
                        }));
                        this.toList = items;
                    }

                    try {
                        var cl = [];
                        var simpleSearch = await utils.api.get(`Apps/Contacts2/Contact/SearchSimple?SearchText=${this.dialstring}&AdditionalInfo=${JSON.stringify(["PhoneNumber","CompanyName","JobTitle","Department"])}`);
                        var formattedInputNumber = careHelpfulFunctions.formatPhoneNumber(this.dialstring);

                        simpleSearch.forEach((contact) => {
                            if (contact.PhoneNumbers.length)
                            {
                                var searchTerm = this.dialstring;
                                var correctPn = contact.PhoneNumbers.find(pn => careHelpfulFunctions.formatPhoneNumber(pn.phonenumber) == formattedInputNumber || (pn.phonenumber.includes(searchTerm) && searchTerm.length > 6));
                                var contactLabel = `${contact.first_display || ''} ${contact.last_display || ''}`;
                                cl.push(
                                {
                                    text: contactLabel,
                                    title: contactLabel,
                                    subtitle: `${contact.PhoneNumbers.map(function(ph) { return careHelpfulFunctions.formatPhoneNumber(ph.phonenumber); }).join(", ")}`,
                                    value: contact,
                                    icon: 'mdi mdi-card-account-details',
                                    searchby: `${contactLabel} (${contact.PhoneNumbers.map(function(ph) { return careHelpfulFunctions.formatPhoneNumber(ph.phonenumber); }).join(", ")})`,
                                    contact_id: contact.contact_id,
                                    phonenumber: correctPn != null ? careHelpfulFunctions.formatPhoneNumber(correctPn.phonenumber) : careHelpfulFunctions.formatPhoneNumber(contact.PhoneNumbers[0].phonenumber)
                                });
                            }
                        });

                        this.toContactList = cl;
                    }
                    catch(err) {
                        console.log(err);
                    }
                } else {
                    this.toContactList = [];
                    if (!this.dialstring || this.dialstring.length <= 1)
                        await this.loadToList();
                }
            },
            dialstringEnter() {
                if (this.dialstring && (!this.showingToList || this.filteredToList.length < 1))
                    this.dialPhone();
                else if (this.showingToList && this.toSelected >= 0 && this.filteredToList.length > 0 && this.toSelected < this.filteredToList.length) {
                    const choice = this.filteredToList[this.toSelected];
                    this.dialstring = choice.value.isuser ? choice.title : (choice.text || choice.title);
                    this.showingToList = false;
                }
            },
            dialstringDown() {
                if (this.showingToList && this.toList.length > 0) {
                    this.toSelected++;
                    if (this.toSelected >= this.toList.length)
                        this.toSelected = 0;
                }
            },
            dialstringUp() {
                if (this.showingToList && this.toList.length > 0) {
                    this.toSelected--;
                    if (this.toSelected < 0)
                        this.toSelected = this.toList.length - 1;
                }
            },

            callClicked() {
                this.showingToList = false;
                this.dtmfHistory = '';
                this.dialPhone();
            },
            holdAndDialClicked() {
                this.showingToList = false;
                this.dialPhone('DialPrivate');
            },
            addCallClicked() {
                this.dialPhone('Dial');
            },
            blindTransferClicked() {
                this.dtmfHistory = '';
                this.dialPhone('TransferTo');
            },
            async dialPhone(method) {
                if (!this.dialstring) {
                    if (this.toList.length > 0) {
                        this.dialstring = this.toList[0].value.isuser ? this.toList[0].name : this.toList[0].value.phonenumber;
                        this.searchDialDirty = false;
                        this.syncSearchDialInput();
                    }
                }
                else {
                    let queryString = "";
                    queryString += `DialString=${encodeURIComponent(this.dialstring)}`;
                    queryString += `&From=${this.currentFrom}`;

                    try {
                        const num = await utils.api.get(`Apps/Common/ResolveDialString?${queryString}`);
                        if (!num || !num.Success) {
                            EventBus.$emit('v-toast', {
                                type: 'warning',
                                name: 'dialerror',
                                text: this.Translate('Dial Failed'),
                                subtext: `${this.Translate('The number entered is not a valid phone number or user')}: ${this.dialstring}`,
                                context: this,
                            });
                            return;
                        } else {
                            num.CallType = "PBX";
                        }
                        this.callHSM.sendEvent(method || 'Dial', undefined, undefined, { DialInfo: num });

                        this.dialstring = '';
                        this.syncSearchDialInput();
                    }
                    catch (err) {
                        EventBus.$emit('v-toast', {
                            type: 'error',
                            name: 'dialerror',
                            text: this.Translate('Dial Failed'),
                            subtext: `${this.Translate('An error occurred attempting to dial')} '${this.dialstring}': ${JSON.stringify(err)}`,
                            context: this,
                        });
                    }
                }
            },
            endAllClicked() {
                this.dtmfHistory = '';
                this.callHSM.sendEvent('HangUpAll', undefined, undefined, { });
            },
            dropOut() {
                this.dtmfHistory = '';
                this.callHSM.sendEvent('Transfer', undefined, undefined, {});
            },
            muteClicked() {
                const aleg = this.callHSM.Vars.ALegHSM;
                if (!aleg) return;

                if (aleg.CurrentState == 'Listening.Active') {
                    if (!aleg.Vars.Muted)
                        aleg.sendEvent('DoMute', undefined, undefined, {});
                    else
                        aleg.sendEvent('DoUnmute', undefined, undefined, {});
                }
            },
            callControlClicked(call) {
                switch (call.CurrentState) {
                    case 'Interacting.Listening.Active.Linked':
                        call.sendEvent('Hold', undefined, undefined, {});
                        break;

                    case 'Interacting.Listening.Active.Unlinked':
                        call.sendEvent('Restore', undefined, undefined, {});
                        break;
                }
            },
            endOneCall(call) {
                this.dtmfHistory = '';
                call.sendEvent('HangUp', undefined, undefined, {});
            },
            copySessionID(call) {
                navigator.clipboard.writeText(call.Vars.Call.SessionId);
            },

            alphaToDTMF(alpha) {
                if (alpha.length > 1)
                    return '';
                else if (['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '*', '#'].includes(alpha))
                    return alpha;
                else if ((alpha >= 'a' && alpha <= 'c') || (alpha >= 'A' && alpha <= 'C'))
                    return '2';
                else if ((alpha >= 'd' && alpha <= 'f') || (alpha >= 'D' && alpha <= 'F'))
                    return '3';
                else if ((alpha >= 'g' && alpha <= 'i') || (alpha >= 'G' && alpha <= 'I'))
                    return '4';
                else if ((alpha >= 'j' && alpha <= 'l') || (alpha >= 'J' && alpha <= 'L'))
                    return '5';
                else if ((alpha >= 'm' && alpha <= 'o') || (alpha >= 'M' && alpha <= 'O'))
                    return '6';
                else if ((alpha >= 'p' && alpha <= 's') || (alpha >= 'P' && alpha <= 'S'))
                    return '7';
                else if ((alpha >= 't' && alpha <= 'v') || (alpha >= 'T' && alpha <= 'V'))
                    return '8';
                else if ((alpha >= 'w' && alpha <= 'z') || (alpha >= 'W' && alpha <= 'Z'))
                    return '9';
                else if (alpha == '+')
                    return '0';
                else
                    return '';
            },
            dtmfInput(alpha) {
                // Called when a key is pressed when inside the keypad text field

                alpha.preventDefault();
                const digit = this.alphaToDTMF(alpha.key);
                if (digit)
                    this.senddtmf(digit);
            },
            senddtmf(digit) {
                const aleg = this.callHSM.Vars.ALegHSM;
                if (!aleg) return;

                aleg.sendEvent('DoDTMF', undefined, undefined, digit);
                this.dtmfHistory += digit;
            },

            startConferenceClicked(e) {
                this.conferenceStatus.AsModerator = true;
                this.conferenceStatus.ModeratorName = 'Self';
                this.callHSM.sendEvent('Conference', undefined, undefined, { AsModerator: true, ModeratorID: token.UserID() });
            },
            endConferenceClicked(e) {
                this.callHSM.sendEvent('HangUpAll', undefined, undefined, { });
            },
            joinConferenceClicked(e) {
                this.showJoinConferenceDialog = true;
            },
            leaveConferenceClicked(e) {
                this.callHSM.sendEvent('Leave', undefined, undefined, {});
            },
            conferenceMemberToggleMute(call) {
                if (!call.Vars.Muted)
                {
                    call.sendEvent('DoMute');
                    call.Vars.Call.Talking = false;
                }
                else
                    call.sendEvent('DoUnmute');
            },

            async lookupCallerIdName(callerid) {
                try {
                    const data = await utils.api.get(`Apps/Common/UserPhoneContact/fullname?PhoneNumber=${callerid}`);
                    this.callerIdName = data != 'NotFound' ? data : this.Translate('Internal User');
                }
                catch (e) {
                    utils.warn(`SoftPhone.lookupCallerIdName(callerid:${callerid}) - exception`, e);
                    this.callerIdName = this.Translate('Internal User');
                }
            },
            acceptIncomingCall(e) {
                const aleg = this.callHSM.Vars.ALegHSM;
                if (aleg)
                    aleg.sendEvent('Accept');
            },
            declineIncomingCall(e) {
                const aleg = this.callHSM.Vars.ALegHSM;
                if (aleg)
                    aleg.sendEvent('Reject');
            },

            phoneSettingsIconClicked(e) {
                utils.executeAndCompileAllActions(this.controlData.PhoneSettingsActions, null, this);
            },
            conferenceSettingsIconClicked(e) {
                utils.executeAndCompileAllActions(this.controlData.ConferenceSettingsActions, null, this);
            },

            loadModeratorNamesFocused(e) {
                this.loadModeratorNames();
            },
            async loadModeratorNames() {
                const data = await utils.api.get('Apps/GetCustomerUsers');
                if (data)
                    this.moderatorNames = data.map(a => ({
                        text: a.FullName,
                        value: a.UserID,
                    }));
            },
            moderatorNamesEnter(e) {
                e.preventDefault();
                e.cancelBubble = true;
                e.stopPropagation();
                // Prevent Enter from causing the page to reload (really!)
            },
            moderatorInput(value) {
                this.moderatorUserID = value;
            },
            moderatorAccept() {
                if (this.moderatorUserID) {
                    const name = this.moderatorNames.find(a => a.value == this.moderatorUserID);
                    if (name) {
                        this.conferenceStatus.ModeratorName = name.text;
                        this.conferenceStatus.ModeratorID = this.moderatorUserID;
                        this.conferenceStatus.AsModerator = false;
                        this.callHSM.sendEvent('Conference', undefined, undefined, this.conferenceStatus);

                        this.showJoinConferenceDialog = false;
                    }
                }
            },
        },
    };
</script>

<style scoped>
    .headerbar {
        display: flex;
        flex-direction: row;
    }

    .inputbar {
        display: flex;
        flex-direction: column;
    }

    .dialbar {
        display: flex;
    }

    .dialpad {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .dialpadbutton {
        font-size: 1.3em;
    }

    .digit {
        text-align: center;
        margin-bottom: 0.2em;
        font-size: 1em;
        color: #007bff;
    }

    .alpha {
        text-align: center;
        font-size: .5em;
        margin-top: -0.75em;
    }

    .conferencebar {
        display: flex;
        justify-content: space-evenly;
    }

    .activecalls {
        display: flex;
        flex-direction: column;
    }

    .generalcallcontrols {
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        border-bottom-width: 1px;
        border-bottom-color: var(--v-lightGreyBorder-base);
        border-bottom-style: solid;
        background-color: var(--v-pageBackground-base);
        display: flex;
        align-items: center;
    }

    .callcontrolscontainer {
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
        display: flex;
        flex-direction: column;
        overflow: hidden;
    }

    .callcontrols {
        display: flex;
        align-items: center;
        gap: 20px;
    }

    .alertingbar {
        display: flex;
        flex-direction: column;
        background-color: #feeeee;
        padding: 15px;
        border-radius: 8px;
        animation: blink-animation-alerting .8s linear infinite;
    }
    @keyframes blink-animation-alerting {
        to {
            background-color: white;
        }
    }

    .incomingAlertingButtons {
        display: flex;
        justify-content: center;
        gap: 20px;
    }

    .incomingAlertingStyles {
        font-size: larger;
        margin: 15px;
    }

    .from_title {
        font-size: inherit;
        font-weight: bolder;
    }

    .from_subtitle {
        font-size: smaller;
    }

    .call_state_dialing {
        background-color: #a7e2a5;
        animation: blink-animation-dialing .8s linear infinite;
    }
    @keyframes blink-animation-dialing {
        to {
            background-color: #8890e4;
        }
    }

    .call_state_normal {
        background-color: #a7e2a5;
    }

    .call_state_onhold {
        background-color: #efe194;
    }

    .call_state_dropped {
        background-color: #efe194;
        animation: blink-animation-dropped .8s linear infinite;
    }
    @keyframes blink-animation-dropped {
        to {
            /*visibility: hidden;*/
            background-color: #e48888;
        }
    }

    .call_state_conference {
        background-color: #f1f2ff;
    }

    .hold-dial-split {
        gap: 0;
    }

    .softphone-btn-icon {
        margin-left: 10px;
    }

</style>
